// extracted by mini-css-extract-plugin
export default {"blockCard":"Thumb_blockCard__WEHNe","imgCard":"Thumb_imgCard__AuHH1","titreCard":"Thumb_titreCard__AJXq5"};